import { useEffect, useState } from 'react';

import { VideoStreamService, type StreamSession } from '../services/VideoStreamService';

interface UseCampaignStreamsResult {
  streams: StreamSession[];
  loading: boolean;
  error: Error | null;
  janusRoomId?: number;
}

/**
 * Hook to fetch and manage streams for a specific campaign
 * @param campaignId - The ID of the campaign to fetch streams for
 * @returns An object containing streams, loading state, error, and Janus room ID
 */
export const useCampaignStreams = (campaignId: string | number): UseCampaignStreamsResult => {
  const [streams, setStreams] = useState<StreamSession[]>([]);
  const [janusRoomId, setJanusRoomId] = useState<number>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchStreams = async (): Promise<void> => {
      try {
        setLoading(true);
        const { streams: streamStates, janus_room_id } = await VideoStreamService.getCampaignStreams(campaignId);
        console.log(streamStates);
        setStreams(streamStates);
        setJanusRoomId(janus_room_id);
      } catch (err) {
        console.error('Error fetching campaign streams:', err);
        setError(err as Error);
      } finally {
        setLoading(false);
      }
    };

    if (campaignId) {
      fetchStreams();
    } else {
      setLoading(false);
    }
  }, [campaignId]);

  return { streams, loading, error, janusRoomId };
};
